var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 26.7273C6.97091 26.7273 1.27274 21.0291 1.27274 14C1.27274 6.97091 6.97091 1.27274 14 1.27274C21.0291 1.27274 26.7273 6.97091 26.7273 14C26.7273 21.0291 21.0291 26.7273 14 26.7273Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.75C14.75 7.33437 14.4156 7 14 7C13.5844 7 13.25 7.33437 13.25 7.75V13.25H7.75C7.33437 13.25 7 13.5844 7 14C7 14.4156 7.33437 14.75 7.75 14.75H13.25V20.25C13.25 20.6656 13.5844 21 14 21C14.4156 21 14.75 20.6656 14.75 20.25V14.75H20.25C20.6656 14.75 21 14.4156 21 14C21 13.5844 20.6656 13.25 20.25 13.25H14.75V7.75Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionClosed);
export default __webpack_public_path__ + "static/media/accordion-closed.e5abbf160363207a2e57fb49e644578a.svg";
export { ForwardRef as ReactComponent };